import type { Item } from '@streepaf/shared'

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // Older browsers and insecure contexts have no clipboard API.
    try {
      const field = document.createElement('textarea')
      field.value = text
      field.setAttribute('readonly', '')
      field.style.position = 'fixed'
      field.style.opacity = '0'
      document.body.appendChild(field)
      field.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(field)
      return ok
    } catch {
      return false
    }
  }
}

export function whatsappUrl(title: string, url: string): string {
  return `https://wa.me/?text=${encodeURIComponent(`${title}\n${url}`)}`
}

export function canWebShare(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function'
}

export async function webShare(title: string, url: string): Promise<void> {
  try {
    await navigator.share({ title, url })
  } catch {
    // The user dismissing the sheet is not an error.
  }
}

/** Plain text for pasting into a chat app. */
export function listAsText(title: string, emoji: string | null, items: Item[]): string {
  const lines = [[emoji, title].filter(Boolean).join(' '), '']
  for (const item of items) {
    if (item.kind === 'section') {
      lines.push('', item.text.toUpperCase())
      continue
    }
    const suffix = [
      item.quantity ? `(${item.quantity})` : '',
      item.claimedBy ? `— ${item.claimedBy}` : '',
    ]
      .filter(Boolean)
      .join(' ')
    lines.push(`${item.checked ? '☑' : '☐'} ${item.text}${suffix ? ` ${suffix}` : ''}`)
  }
  return lines.join('\n').trim()
}
